import { API_ROOT } from '../../config/config'
import { doGet, doPost, doPut, doDownload, doDeleteData, doPostFiles } from './utils'

// const API_ROOT = 'http://localhost:9012/api'

const API_PATH = API_ROOT + '/subproject/setting/form'

//จัดการประเด็นสำหรับโครงการย่อย
export const getManageProposalForm = () => {
  const url = `${API_PATH}/manage/page`
  return doGet(url)
}

export const getManageProposalFormById = (formId) => {
  const url = `${API_PATH}/tempelte/${formId}`
  return doGet(url)
}

export const saveManageProposalForm = (formId, request) => {
  const url = `${API_PATH}/tempelte/${formId}`
  return doPost(url, request)
}

export const delManageProposalForm = (formId) => {
  const url = `${API_PATH}/tempelte/${formId}`
  return doDeleteData(url)
}

export const createManageProposalForm = (request) => {
  const url = `${API_PATH}/tempelte/create`
  return doPost(url, request)
}

export const createNewVersionManageProposalForm = (id) => {
  const url = `${API_PATH}/tempelte/${id}/create-new-version`
  return doPut(url)
}

//1.ชื่อโครงการ
export const getSettingFormProjectName = (formId) => {
  const url = `${API_PATH}/project-name/${formId}`
  return doGet(url)
}

export const getSettingFormProjectNamePreView = (formId) => {
  const url = `${API_PATH}-file/project-name/${formId}/preview`
  return doGet(url)
}

export const saveSettingFormProjectName = (formId, request) => {
  const url = `${API_PATH}/project-name/${formId}`
  return doPost(url, request)
}

//2.ผู้เสนอโครงการ
export const getSettingFormProjectProponent = (formId) => {
  const url = `${API_PATH}/project-proponent/${formId}`
  return doGet(url)
}

export const getSettingFormProjectProponentPreView = (formId) => {
  const url = `${API_PATH}-file/project-proponent/${formId}/preview`
  return doGet(url)
}

export const saveSettingFormProjectProponent = (formId, request) => {
  const url = `${API_PATH}/project-proponent/${formId}`
  return doPost(url, request)
}

//3.ผู้รับผิดชอบโครงการ/ผู้รับทุน
export const getSettingFormProjectResponsiblerAndGrantee = (formId) => {
  const url = `${API_PATH}/project-responsibler-grantee/${formId}`
  return doGet(url)
}

export const getSettingFormProjectResponsiblerAndGranteePreView = (formId) => {
  const url = `${API_PATH}-file/project-responsibler-grantee/${formId}/preview`
  return doGet(url)
}

//3.1.ผู้รับผิดชอบโครงการ
export const getSettingFormProjectResponsibler = (formId) => {
  const url = `${API_PATH}/project-responsibler/${formId}`
  return doGet(url)
}

export const saveSettingFormProjectResponsibler = (formId, request) => {
  const url = `${API_PATH}/project-responsibler/${formId}`
  return doPost(url, request)
}
//3.2.ผู้รับทุน
export const getSettingFormProjectGrantee = (formId) => {
  const url = `${API_PATH}/project-grantee/${formId}`
  return doGet(url)
}

export const saveSettingFormProjectGrantee = (formId, request) => {
  const url = `${API_PATH}/project-grantee/${formId}`
  return doPost(url, request)
}

//4.ผู้ร่วมทำโครงการ
export const getSettingFormProjectCoMaker = (formId) => {
  const url = `${API_PATH}/project-comaker/${formId}`
  return doGet(url)
}

export const getSettingFormProjectCoMakerPreView = (formId) => {
  const url = `${API_PATH}-file/project-comacker/${formId}/preview`
  return doGet(url)
}

export const saveSettingFormProjectCoMaker = (formId, request) => {
  const url = `${API_PATH}/project-comaker/${formId}`
  return doPost(url, request)
}

//5.คุณสมบัติพื้นฐานและลักษณะต้องห้ามผู้เสนอโครงการ
export const getSettingFormProjectFeature = (formId) => {
  const url = `${API_PATH}/project-feature/${formId}`
  return doGet(url)
}

export const getSettingFormProjectFeaturePreView = (formId) => {
  const url = `${API_PATH}-file/project-feature/${formId}/preview`
  return doGet(url)
}

export const saveSettingFormProjectFeature = (formId, request) => {
  const url = `${API_PATH}/project-feature/${formId}`
  return doPost(url, request)
}

//6.ความเป็นมา/หลักการและเหตุผล/ความสำคัญของปัญหา
export const getSettingFormProjectBackground = (formId) => {
  const url = `${API_PATH}/project-background/${formId}`
  return doGet(url)
}

export const getSettingFormProjectBackgroundPreView = (formId) => {
  const url = `${API_PATH}-file/project-background/${formId}/preview`
  return doGet(url)
}

export const saveSettingFormProjectBackground = (formId, request) => {
  const url = `${API_PATH}/project-background/${formId}`
  return doPost(url, request)
}

//7.วัตถุประสงค์ ผลลัพธ์และตัวชี้วัด
export const getSettingFormProjectObjectiveOutcomeIndicator = (formId) => {
  const url = `${API_PATH}/project-objective-outcome-indicator/${formId}`
  return doGet(url)
}

export const getSettingFormProjectObjectiveOutcomeIndicatorPreView = (formId) => {
  const url = `${API_PATH}-file/project-objective-outcome-indicator/${formId}/preview`
  return doGet(url)
}

export const saveSettingFormProjectObjectiveOutcomeIndicator = (formId, request) => {
  const url = `${API_PATH}/project-objective-outcome-indicator/${formId}`
  return doPost(url, request)
}

//8.  กลุ่มเป้าหมายและพื้นที่ดำเนินการ
export const getSettingFormTargetGroupOperationArea = (formId) => {
  const url = `${API_PATH}/project-target-group-operation-area/${formId}`
  return doGet(url)
}

export const getSettingFormTargetGroupOperationAreaPreView = (formId) => {
  const url = `${API_PATH}-file/project-target-group-area/${formId}/preview`
  return doGet(url)
}

//8.1  กลุ่มเป้าหมาย
export const getSettingFormTargetGroup = (formId) => {
  const url = `${API_PATH}/project-target-group/${formId}`
  return doGet(url)
}

export const saveSettingFormTargetGroup = (formId, request) => {
  const url = `${API_PATH}/project-target-group/${formId}`
  return doPost(url, request)
}
//8.2 พื้นที่ดำเนินการ
export const getSettingFormOperationArea = (formId) => {
  const url = `${API_PATH}/project-operation-area/${formId}`
  return doGet(url)
}

export const saveSettingFormOperationArea = (formId, request) => {
  const url = `${API_PATH}/project-operation-area/${formId}`
  return doPost(url, request)
}

//9.ระยะเวลาดำเนินงาน
export const getSettingFormOperatingPeriod = (formId) => {
  const url = `${API_PATH}/project-operating-period/${formId}`
  return doGet(url)
}

export const getSettingFormOperatingPeriodPreView = (formId) => {
  const url = `${API_PATH}-file/project-operation-period/${formId}/preview`
  return doGet(url)
}

export const saveSettingFormOperatingPeriod = (formId, request) => {
  const url = `${API_PATH}/project-operating-period/${formId}`
  return doPost(url, request)
}

//10.กิจกรรมการดำเนินงาน/แผนการดำเนินงาน
export const getSettingFormActivities = (formId) => {
  const url = `${API_PATH}/project-activities/${formId}`
  return doGet(url)
}

export const getSettingFormActivitiesPreView = (formId) => {
  const url = `${API_PATH}-file/project-activities/${formId}/preview`
  return doGet(url)
}

export const saveSettingFormActivities = (formId, request) => {
  const url = `${API_PATH}/project-activities/${formId}`
  return doPost(url, request)
}

export const saveSettingFormActivity = (formId, request) => {
  const url = `${API_PATH}/project-activity/${formId}`
  return doPost(url, request)
}

export const deleteSettingFormActivity = (formId, id) => {
  const url = `${API_PATH}/project-activity/${formId}/${id}`
  return doDeleteData(url)
}

//11.การสนับสนุนทรัพยากรจากหน่วยงานอื่น
export const getSettingFormOtherSupport = (formId) => {
  const url = `${API_PATH}/project-other-support/${formId}`
  return doGet(url)
}

export const getSettingFormOtherSupportPreView = (formId) => {
  const url = `${API_PATH}-file/project-other-support/${formId}/preview`
  return doGet(url)
}

export const saveSettingFormOtherSupport = (formId, request) => {
  const url = `${API_PATH}/project-other-support/${formId}`
  return doPost(url, request)
}

//12.จัดการ วิธีรายงานผลลัพธ์ของโครงการ
export const getSettingFormResultsReport = (formId) => {
  const url = `${API_PATH}/project-results-report/${formId}`
  return doGet(url)
}

export const getSettingFormResultsReportPreView = (formId) => {
  const url = `${API_PATH}-file/project-results-report/${formId}/preview`
  return doGet(url)
}

export const saveSettingFormResultsReport = (formId, request) => {
  const url = `${API_PATH}/project-results-report/${formId}`
  return doPost(url, request)
}

//13.องค์กรภาคีที่ร่วมดำเนินงาน
export const getSettingFormPartner = (formId) => {
  const url = `${API_PATH}/project-partner/${formId}`
  return doGet(url)
}

export const getSettingFormPartnerPreView = (formId) => {
  const url = `${API_PATH}-file/project-partner/${formId}/preview`
  return doGet(url)
}

export const saveSettingFormPartner = (formId, request) => {
  const url = `${API_PATH}/project-partner/${formId}`
  return doPost(url, request)
}

//14.เอกสารแนบท้ายโครงการ
export const getSettingFormProjectAttachments = (formId) => {
  const url = `${API_PATH}/project-attachments/${formId}`
  return doGet(url)
}

export const getSettingFormProjectAttachmentsPreView = (formId) => {
  const url = `${API_PATH}-file/project-attachments/${formId}/preview`
  return doGet(url)
}

export const saveSettingFormProjectAttachments = (formId, request) => {
  const url = `${API_PATH}/project-attachments/${formId}`
  return doPost(url, request)
}

//15.ภาคผนวก
export const getSettingFormProjectAppendix = (formId) => {
  const url = `${API_PATH}/project-appendix/${formId}`
  return doGet(url)
}

export const getSettingFormProjectAppendixPreView = (formId) => {
  const url = `${API_PATH}-file/project-appendix/${formId}/preview`
  return doGet(url)
}

export const saveSettingFormProjectAppendix = (formId, request) => {
  const url = `${API_PATH}/project-appendix/${formId}`
  return doPostFiles(url, request)
}

export const updateSettingFormProjectAppendixName = (formId, request) => {
  const url = `${API_PATH}/project-appendix/${formId}/attach/update`
  return doPut(url, request)
}

export const updateSettingFormProjectAppendixSeq = (formId, fileId, seqNo) => {
  const url = `${API_PATH}/project-appendix/${formId}/attach/${fileId}/${seqNo}`
  return doPut(url)
}

export const delSettingFormProjectAppendix = (formId, fileId) => {
  const url = `${API_PATH}/project-appendix/${formId}/attach/${fileId}`
  return doDeleteData(url)
}
